module.exports = __webpack_public_path__ + "static/media/ilustration-3.7785835e.png";